import request from '@/router/axios';

export const getList = (current, size, ascs, params) => {
  return request({
    url: '/api/jida-system/post/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
      ascs,
    }
  })
}

export const getPostList = (tenantId) => {
  return request({
    url: '/api/jida-system/post/select',
    method: 'get',
    params: {
      tenantId
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/jida-system/post/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/jida-system/post/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/jida-system/post/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/jida-system/post/submit',
    method: 'post',
    data: row
  })
}

